import React, { useState } from "react";
import { useEffect } from "react";
import moment from "moment-timezone";

import "./styles.css";

// Set default timezone
moment.tz.setDefault("America/New_York");

const Share = ({
  appointment,
  color = "#333",
  appointmentId,
  appointments,
  handleSetView,
  shared,
  setShared,
  setSelectedEvent
}) => {
  const {
    id = "",
    title = "",
    duration = "",
    descriptionHtml = "",
    image = "",
    price = "",
    quantity,
  } = appointment;
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async function () {
      if (appointmentId) {
        setLoading(true);
        let selectedAppointment;
        try {
          const getBookedResponse = await fetch(
            `${process.env.REACT_APP_SERVER}/share/${appointmentId}`
          );
          const getBooked = await getBookedResponse.json();
          const booked = getBooked.data.order;
          setShared(booked);
          const date = moment(booked.date).format('YYYY-MM-DD')
          const startTime = moment(booked.start_time).format('HH:MM:00')
          const start = moment(`${date} ${startTime}`).toDate()
          setSelectedEvent({start: start, end: booked.end_time, resource: {eventId: booked.event_id, recurring: booked.event_type === "recurring" ? true : false }})

          appointments.forEach((appointment) => {
            if (Number(booked.appointment_id) === Number(appointment.relId)) {
              selectedAppointment = appointment;
            }
          });
          handleSetView("share", selectedAppointment);
          setLoading(false);
        } catch (error) {
          console.log(error);
        }
      }
    })();
  }, []);

  return (
    <>
      {!loading && appointment.title && (
        <div className="ct-modal__details">
          <div className="ct-modal__details--image">
            <img src={image} alt={title} />
          </div>
          <div className="ct-modal__details--content">
            <div className="ct-modal__details--heading--container">
              <span className="ct-modal__details--heading">{title}</span>
              <span className="ct-modal__details--price">
                ${(price * quantity).toFixed(2)}
              </span>
            </div>
            <div className="ct-modal__share--container">
              <span className="ct-modal__share--date">
                {moment(shared.date).format("dddd, MMMM DD, YYYY")}
              </span>
              <span className="ct-modal__share--time">
                {moment(shared.start_time).format("h:mma")} -{" "}
                {moment(shared.end_time).format("h:mma")}
              </span>
            </div>
            {/* <span className="ct-modal__details--subheading">Duration: {duration}</span> */}
            <div
              className="ct-modal__details--preview"
              dangerouslySetInnerHTML={{ __html: descriptionHtml }}
            />
          </div>
        </div>
      )}
      {!loading && !appointment.title && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 16,
          }}
        >
          <span
            style={{
              fontSize: "20px",
              color: "#fd6a4f",
              fontWeight: 700,
            }}
          >
            Cannot find Workshop.
          </span>
          <div style={{ marginTop: 32 }}>
            <button
              className="ct-modal__button"
              onClick={() => handleSetView("main")}
            >
              Back
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Share;
